export default "__VITE_ASSET__p7pHtA2t__"